import { useTranslation } from 'react-i18next'
import { useInView } from 'react-intersection-observer'
import { isEmpty } from 'remeda'
import { dataTestIds } from '@velasca/constants'
import { useRecentProducts } from '@velasca/hooks/use-recent-products'
import { trackEvent } from '@velasca/utils/track-event'
import { ProductsSlider } from '../ProductsSlider/ProductsSlider'
import type { RecentProductsSliderProps } from './RecentProductsSlider.types'

const quickAddEvent = (handle: string) => {
  trackEvent({
    googleAnalytics: {
      eventName: 'recent_quick_add',
      data: { handle },
    },
  })
}

export const RecentProductsSlider = ({
  className,
  showProductType = false,
  arrowVisible = false,
  breakpoints,
  slidesSize = 'lg',
  swapImages = false,
}: RecentProductsSliderProps) => {
  const [ref, inView] = useInView({
    rootMargin: '0px 0px 200px 0px',
    triggerOnce: true,
  })
  const { t } = useTranslation('product')
  const { recentProducts, loading, count } = useRecentProducts({
    swapImages,
    skip: !inView,
  })

  if (count === 0 || (isEmpty(recentProducts) && !loading && inView)) {
    return null
  }

  return (
    <ProductsSlider
      ref={ref}
      className={`product-slider ${className}`}
      loadingSlides={count}
      loading={loading || !inView}
      showProductType={showProductType}
      breakpoints={breakpoints}
      products={recentProducts}
      title={t('recentProductsTitle')}
      subTitle={t('recentProductsSubTitle')}
      arrowVisible={arrowVisible}
      slidesSize={slidesSize}
      dataTestId={dataTestIds.RECENT_PRODUCTS_SLIDER}
      onQuickAdd={quickAddEvent}
      onAddToCart={(handle) => {
        trackEvent({
          googleAnalytics: {
            eventName: 'recent_quick_add_to_cart',
            data: { handle },
          },
        })
      }}
    />
  )
}
